"use strict";
var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var THREE = require("three");

var FootprintInstanceData = function (footprintDescription, model3dPosition, model3dRotation) {
    this.registerInstanceClass(["pads"]);   // TODO: see if we can omit this
    this.registerInstanceClass(["holes"]);   // TODO: see if we can omit this
    lib_core.InstanceBuilder.call(this, footprintDescription);

    this.model3dPosition = this.value("model3dPosition", true, lib_geometry.Coord3d.validator);
    this.model3dRotation = this.value("model3dRotation", true, lib_geometry.Coord3d.validator);

    if (model3dPosition != undefined){
        this.model3dPosition(model3dPosition);
    } else {
        this.model3dPosition(new lib_geometry.Coord3d(0,0,0));
    }

    if (model3dRotation != undefined){
        this.model3dRotation(model3dRotation);
    } else {
        this.model3dRotation(new lib_geometry.Coord3d(0,0,0));
    }
};

lib_core.inherit(FootprintInstanceData, lib_core.InstanceBuilder);
lib_core.JsonParser.registerClass(FootprintInstanceData, "FootprintInstanceData");

module.exports = FootprintInstanceData;

FootprintInstanceData.prototype.getTitle = function () {
    return this.description().metaData().name();// + " v"+ this.description.root.header["version"];
};

FootprintInstanceData.prototype.getDescription = function () {
    return this.description().metaData().description();
};

FootprintInstanceData.prototype.getSummary = function () {
    return this.description().metaData().summary();
};

FootprintInstanceData.prototype.getThumbnailURL = function () {
    return this.root?.asset?.thumbnail;
};

FootprintInstanceData.prototype.bestCenter = function() {
    var boundingBox = this.padsBoundingBox();
    if(!boundingBox){
        boundingBox = this.boundingBox();
    }
    return new lib_geometry.Coord(
        boundingBox.x + boundingBox.width/2,
        boundingBox.y + boundingBox.height/2
    );
};

FootprintInstanceData.prototype.boundingBox = function() {
    return this.description().boundingBox();
};

FootprintInstanceData.prototype.padsBoundingBox = function() {
    return this.description().padsBoundingBox();
};

//copy as much info from the old instance as possible
FootprintInstanceData.prototype.transferDataFromInstance = function(oldInstance) {
    this.model3dPosition(oldInstance.model3dPosition());
    this.model3dRotation(oldInstance.model3dRotation());
};
